import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { DeleteConfirmModal } from '../../../components/generic/DeleteConfirmModal';
import { createModal } from '../../../components/generic/Modal';
import { useDeleteParticipantBehaviourMutation } from '../../../graphql/hooks/useDeleteParticipantBehaviourMutation';
import { useAppContext } from '../../../hooks/useAppContext';

interface Props {
  participantBehaviourId: string;
  participantBehaviourName: string;
  participantId: string;
}

export const ParticipantBehaviourDeleteModal = createModal<Props>((props) => {
  const { participantBehaviourId, participantBehaviourName, participantId, modal } = props;
  const { organization, successToast, errorToast } = useAppContext();
  const mutation = useDeleteParticipantBehaviourMutation();

  const onDelete = React.useCallback(async () => {
    await mutation
      .mutateAsync({
        organizationId: organization.id,
        participantId,
        participantBehaviourId,
      })
      .then(async () => {
        successToast('Behaviour deleted successfully');
      })
      .catch((err) => {
        errorToast(`Error deleting behaviour: ${err.message}`);
      });
  }, [mutation, organization.id, participantBehaviourId, participantId, successToast, errorToast]);

  return (
    <DeleteConfirmModal
      modal={modal}
      heading='Do you want to delete this behaviour?'
      description={
        <ChakraV3.Stack gap={4}>
          <ChakraV3.Text>
            Deleting this behaviour <strong>will remove associated recordings.</strong>
          </ChakraV3.Text>
          <ChakraV3.AlertBanner
            size='sm'
            status='info'
            alignItems='center'
            title='If you want to keep the recordings, consider archiving the behaviour instead.'
          />
        </ChakraV3.Stack>
      }
      confirmation={{ level: 'Level2', confirm: participantBehaviourName }}
      onDelete={onDelete}
      isLoading={mutation.isLoading}
    />
  );
});
